import React, { useId } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './Tooltip.css';
import clsx from 'clsx';
import { LegacyColors } from 'constants';

import Button from '../Button';
import { info } from 'assets/icon';

const shouldPortalTooltipToBody = () => {
  if (typeof document === 'undefined' || !document.body) {
    return false;
  }
  if (typeof process !== 'undefined' && process.env.JEST_WORKER_ID != null) {
    return false;
  }
  return true;
};

const Tooltip = ({
  icon = info,
  iconSize = 18,
  iconColor = LegacyColors.primary,
  display = 'inline-block',
  ariaLabel = 'Tooltip Button',
  type = 'info',
  text = '',
  dataFor = '',
  className,
  clickable = false,
}) => {
  const uid = useId().replace(/:/g, '');
  const tooltipId = dataFor || `alf-tooltip-${uid}`;

  const tooltip = (
    <ReactTooltip
      id={tooltipId}
      place="right"
      type={type}
      effect="solid"
      textColor={LegacyColors.warmGray}
      backgroundColor={LegacyColors.white}
      border
      borderColor={LegacyColors.warmGray}
      className={clsx(className, 'alf-tooltip')}
      clickable={clickable}
      delayHide={500}
    >
      {text}
    </ReactTooltip>
  );

  return (
    <div
      data-tip
      data-for={tooltipId}
      style={{
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        display: display,
        margin: '0px 8px',
      }}
    >
      <Button
        ariaLabel={ariaLabel}
        ariaDescribedBy="tooltip"
        id={tooltipId}
        type="icon"
        style={{
          display: 'inline-flex',
          verticalAlign: 'text-top',
        }}
        htmlType="button"
        icon={
          <img
            alt={ariaLabel}
            src={icon}
            width={iconSize}
            height={iconSize}
            fill={iconColor}
          />
        }
      />
      {shouldPortalTooltipToBody()
        ? createPortal(tooltip, document.body)
        : tooltip}
    </div>
  );
};

Tooltip.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
  display: PropTypes.string,
  ariaLabel: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  dataFor: PropTypes.string,
  clickable: PropTypes.bool,
};

export default Tooltip;
